
import DeductionsDataTable from '../../../../Components/hr/deductions/deductionsIndex/deductionsDataTable'
import PageHeader from '../../../../Components/UI/PageHeader'



const Deductions = () => {
  return (
    <div>
      <PageHeader title="Deductions" showButton={true} url={`${process.env.PUBLIC_URL}/deductionsstore`}/>
      <DeductionsDataTable/></div>
  )
}    
  
export default Deductions